import React from 'react'
import Header from './components/Header'
import './App.css'
import Content from './components/Content'

const App = () => {
  
  return (
    <div className='App'>
      <Header />
      <Content />      
    </div>
  )
}

export default App
